import React          from 'react';
import colors         from '../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        position:       'fixed',
        top:            '50%' ,
        left:           '50%',
        transform:      'translate(-50%, -50%)',
        fontSize:       30,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        borderRadius:   '0.5em',
        transition:     'all 0.5s',
        zIndex:         9999
    },
    button: {
        height:          70,
        width:           200,
        fontSize:        20,
        marginLeft:      5,
        marginRight:     5,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: colors.blue,
        color:           '#FFF',
        cursor:          'pointer'
    }
    
}))

type TextProps = {
    showOptionMenu: boolean;
    handleClick: (val: number) => void;
}

const Text: React.FC<TextProps> = ({ 
    showOptionMenu,
    handleClick
 }) => {

 const classes = useStyles();


  return (
        <div 
          className = { classes.root }
          style     = {{
              opacity: showOptionMenu ? 1 : 0,
              marginTop: showOptionMenu ? 0 : '150vh' 
          }}
        >
           <div 
              dir       = 'rtl'
              className = { classes.button }
              onClick   = { () => { handleClick(0) }}
           >
               בצע שוב
           </div>
           <div 
              dir       = 'rtl'
              className = { classes.button }
              onClick   = { () => { handleClick(1) }}
           >
               חזור אל עמוד הבית
           </div>
        </div>
  );
}



export default Text;








